import { render } from "./Ethiopian_Full_Calendar.vue?vue&type=template&id=394df5b7&scoped=true"
import script from "./Ethiopian_Full_Calendar.vue?vue&type=script&lang=js"
export * from "./Ethiopian_Full_Calendar.vue?vue&type=script&lang=js"

import "./Ethiopian_Full_Calendar.vue?vue&type=style&index=0&id=394df5b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394df5b7"]])

export default __exports__